module.exports = __webpack_public_path__ + "public/media/marketeer-left.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/marketeer-left.png
// module id = ./images/services/marketeer-left.png
// module chunks = 0